import api from './api';

export const getTiposCarroceriasList = async () => {
  try {
    const { data } = await api.get('tipo-carroceria/list');
    return data;
  } catch (error) {
    return { error };
  }
};
